import apiClient from '@/lib/axios';

type ReportFormat = 'pdf' | 'xlsx';

const PDF_MIME_TYPE = 'application/pdf';
const EXCEL_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Downloads a Job Cost Report in the specified format
 */
export const downloadJobCostReport = async (
  jobId: number,
  format: ReportFormat = 'pdf'
): Promise<void> => {
  const response = await apiClient.get(
    `/reports/job-cost/${jobId}?format=${format}`,
    { responseType: 'blob' }
  );

  const mimeType = format === 'pdf' ? PDF_MIME_TYPE : EXCEL_MIME_TYPE;
  const extension = format === 'pdf' ? 'pdf' : 'xlsx';

  const blob = new Blob([response.data], { type: mimeType });
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `job-cost-report-${new Date().toISOString().split('T')[0]}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
};

/**
 * Opens a Job Cost Report as PDF in a new browser tab
 */
export const openJobCostReportPdf = async (jobId: number): Promise<void> => {
  const response = await apiClient.get(
    `/reports/job-cost/${jobId}?format=pdf`,
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], { type: PDF_MIME_TYPE });
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');

  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
};
